"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultNavigationSx = exports.DefaultNavigationListSx = exports.DefaultLogoStyles = exports.DefaultLogoImageStyles = exports.DefaultInnerContainerSx = exports.DefaultCopyrightSx = exports.DefaultContainerSx = exports.DefaultBottomNavSx = void 0;
const merge = require("deepmerge"),
  DefaultBottomNavSx = () => {
    return {
      backgroundColor: "#002234",
      color: "#74949F",
      maxWidth: "100% !important",
      padding: {
        xs: "3.2rem 2rem",
        md: "3.2rem 1rem"
      },
      "ul": {
        alignItems: "center",
        display: {
          xs: "block",
          md: "flex"
        },
        justifyContent: "center",
        margin: "0",
        padding: "0"
      },
      "li": {
        display: {
          xs: "block",
          md: "inline-block"
        },
        "fontSize": "1.3rem",
        margin: "0",
        padding: {
          xs: "0",
          md: "0 2rem"
        },
        textAlign: "center",
        "+ li": {
          padding: {
            xs: "1rem 0 0",
            md: "0 2rem"
          }
        },
        "a": {
          color: "inherit",
          textDecoration: "none",
          "&:hover, &:active, &:focus-visible": {
            textDecoration: "underline"
          }
        }
      },
      ".footer--noNavigation &": {
        background: "transparent",
        color: "white"
      }
    };
  },
  DefaultContainerSx = theme => {
    return merge(theme.mixins.container.outer, {
      backgroundColor: "rgba(0, 69, 105, 1)",
      backgroundImage: `url("${process.env.PUBLIC_URL}/general/images/footer/pheaa_cap.svg"),
	 			url("${process.env.PUBLIC_URL}/general/images/footer/Triangle-Pattern-042520-Blue.svg")`,
      backgroundPosition: "100% -40px,right top",
      backgroundRepeat: "no-repeat,repeat",
      color: "white",
      fontSize: "1.4rem",
      marginTop: "0",
      padding: {
        xs: "7.4rem 2rem 0 !important",
        lg: "7.4rem 4rem 0 !important"
      },
      zIndex: "1",
      "&.footer": {
        marginTop: {
          xs: theme.contentSpacing.mobileFooter,
          md: theme.contentSpacing.desktopFooter
        }
      },
      "&.footer--noMarginTop": {
        marginTop: "0"
      },
      "&.footer--noNavigation": {
        alignItems: "center",
        borderTop: `${theme.palette.footer.border} solid 2rem`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        padding: "4rem 1rem 4.5rem !important"
      },
      "a": {
        color: "white",
        textDecoration: "none",
        "&:hover,&:active,&:focus-visible": {
          color: "white",
          textDecoration: "underline"
        }
      }
    });
  },
  DefaultCopyrightSx = theme => {
    return {
      marginBottom: {
        xs: "6rem",
        md: "4rem"
      },
      "a": {
        color: "white",
        textDecoration: "none",
        "&:hover,&:active,&:focus-visible": {
          textDecoration: "underline"
        }
      },
      WebkitHyphens: "none",
      hyphens: "none",
      ".footer--noNavigation &": {
        borderTop: `0.1rem solid ${theme.palette.footer.separator}`,
        display: "inline-block",
        lineHeight: "1.6",
        margin: "0",
        padding: "3rem 0 0",
        textAlign: "center"
      }
    };
  },
  DefaultInnerContainerSx = theme => {
    return merge(theme.mixins.container.inner, {
      alignItems: "flex-start",
      display: "flex",
      justifyContent: "flex-start",
      padding: "0",
      "> *": {
        flexBasis: "auto",
        flexGrow: "1",
        flexShrink: "1"
      },
      "a": {
        color: "#FFFFFF",
        "&:hover,&:active,&:focus-visible": {
          color: "#FFFFFF"
        }
      }
    });
  },
  DefaultLogoStyles = () => {
    return {
      background: "none",
      border: "none",
      boxShadow: "unset",
      display: "inline-block",
      margin: "0",
      padding: "0"
    };
  },
  DefaultLogoImageStyles = () => {
    return {
      objectFit: "contain"
    };
  },
  DefaultNavigationSx = () => {
    return {
      columnGap: {
        xs: "0",
        sm: "4rem"
      },
      display: {
        xs: "block",
        sm: "grid"
      },
      gridTemplateColumns: "repeat(3, 1fr)",
      padding: {
        xs: "0",
        md: "0 4rem 0 0 !important"
      }
    };
  },
  DefaultNavigationListSx = theme => {
    return {
      "h2": {
        borderBottomColor: "rgba(234, 234, 235, 0.3)",
        borderBottomStyle: "solid",
        borderBottomWidth: "0.1rem",
        display: "inline-block",
        fontFamily: theme.fontFamilies.bold,
        fontSize: "2rem",
        lineHeight: "1.2",
        margin: "0 0 1rem",
        padding: "0 1em 1rem 0"
      },
      "ul": {
        margin: "0 0 4rem",
        padding: "0"
      },
      "li": {
        display: "block",
        margin: "0",
        minHeight: "3rem",
        padding: "0.5rem 0",
        "a": {
          background: "transparent",
          color: "inherit",
          textDecoration: "none",
          "&:hover, &:active, &:focus-visible": {
            textDecoration: "underline"
          }
        }
      }
    };
  };
exports.DefaultNavigationListSx = DefaultNavigationListSx;
exports.DefaultNavigationSx = DefaultNavigationSx;
exports.DefaultLogoImageStyles = DefaultLogoImageStyles;
exports.DefaultLogoStyles = DefaultLogoStyles;
exports.DefaultInnerContainerSx = DefaultInnerContainerSx;
exports.DefaultCopyrightSx = DefaultCopyrightSx;
exports.DefaultContainerSx = DefaultContainerSx;
exports.DefaultBottomNavSx = DefaultBottomNavSx;